import { triggerEvent, isVisible, querySelectorChildren, addEventSelectorListener, addEventMatchesListener } from "./utils";

//
// Tato třída obsahuje kód, který je trochu "kontroverzní" (není to úplně dobrý nápad).
// Smyslem je zjednodušit zápis volání funkcí, které očekávají element jako svůj argument,
// tj. jde o operace s/nad elementy a tak se rozšíření jejich prototypu (byť
// jde o silně nedoporučované řešení) nabízí. Zde si tuto "kontroverzi" můžeme dovolit,
// protože kód není rozsháhlý.
//
// Pokud by se v budoucnu ukázalo, že tento přístup opravdu nebyl dobrý nápad,
// všechny funkce jsou psány tak, aby je šlo kdykoliv nahradit voláním přes "apply" nebo "bind",
// kde jako první argument bude vždy daný element.
//

if (!Element.prototype.trigger && !Document.prototype.trigger && !Element.prototype.isVisible && !Element.prototype.querySelectorChildren && !Document.prototype.addEventSelectorListener && !Element.prototype.addEventSelectorListener && !Document.prototype.addEventMatchesListener && !Element.prototype.addEventMatchesListener) {
	Element.prototype.trigger = Document.prototype.trigger = triggerEvent;
	Element.prototype.isVisible = isVisible;
	Element.prototype.querySelectorChildren = querySelectorChildren;
	Element.prototype.addEventSelectorListener = Document.prototype.addEventSelectorListener = addEventSelectorListener;
	Element.prototype.addEventMatchesListener = Document.prototype.addEventMatchesListener = addEventMatchesListener;
}
else {
	console.error("Některé z metod v třídě \"Element\" již existují. Zkontrolujte \"dom_extend.js\".");
}
